export enum ArticleType {
  CareArticle = 'careArticle',
  LearnLibrary = 'learnArticle',
  Lesson = 'lesson',
}
